import { MatDialogConfig } from "@angular/material/dialog";

export function getPosStandardModalDialogConfig(customWidth?: string, customhHeight?: string, isLargeDialog: boolean = false) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = customWidth ?? '400px';
    dialogConfig.height = customhHeight ?? '400px';
    dialogConfig.panelClass = isLargeDialog ? ['flex-1', 'relative', 'overflow-y-scroll', 'lg:overflow-y-visible', 'focus:outline-none', 'up-dialog-container', 'messageBox'] : ['up-dialog-container', 'messageBox'];
    return dialogConfig;
}